import styled from "styled-components";
import theme from "../../../UI/theme";
import MusicPlayerItem from "./MusicPlayerItem";
import { useContext } from "react";
import UserContext from "../../../hooks/UserContext";

const Container = styled.div`
    padding: 0 8px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
    touch-action: manipulation;
    border-radius: 2px;
`

const Header = styled.label`
    font-size: 1.5rem;
    line-height: 50px;

    @media only screen and (max-width: ${theme.screenSizes.medium - 1}px) {
        line-height: 40px;
    }
`

const PlayerContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    // grid-gap: 2px;
`

const PlayerName = styled.label`
    color: ${theme.colors.darkSpace50};
`

const MusicPlayerList = ({ musicPlayers, userObjectRestrictions, hubs }) => {

    const userContext = useContext(UserContext);

    const showMusicHeader = musicPlayers.some(musicPlayer => 
        !userObjectRestrictions?.some(
            restriction => restriction.objectId === musicPlayer.musicPlayerId &&
            restriction.userId === userContext.user.userId
        )
    );

    return <Container>
        {showMusicHeader &&
            <Header>Music</Header>
        }
        {musicPlayers?.map((musicPlayer) => {

            let showMusicPlayer = !userObjectRestrictions?.some(restriction => 
                restriction.objectId === musicPlayer.musicPlayerId &&
                restriction.userId === userContext.user.userId
            );

            return (<>
                {showMusicPlayer &&
                    <PlayerContainer>
                        <PlayerName>{musicPlayer?.name}</PlayerName>
                        <MusicPlayerItem key={musicPlayer?.musicPlayerId} musicPlayer={musicPlayer} hubs={hubs} />
                    </PlayerContainer>
                }
            </>)
        })}
    </Container>
}

export default MusicPlayerList;